<template>
  <div class="stage-test">
    <div class="top"></div>
    <div class="bottom">
      <div class="start" @click="start"></div>
    </div>
    <div class="left"></div>
    <div class="right"></div>
    <div class="content">
      <div
        v-for="(item, index) in courseList"
        :key="item.code"
        :class="[`course${index}`, selectedKey=== item.code? 'active': '']"
        @click="selectCourse(item.code)"
      >
        <span class="course-name">{{item.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/graphql/test';

export default {
  data() {
    return {
      selectedKey: '',
      courseList: [],
    };
  },
  computed: {
    type() {
      if (this.selectedKey === 'English') {
        return 'BKW';
      }
      if (['LS', 'DL', 'SW', 'SDSHK'].includes(this.selectedKey)) {
        return 'DiShengHuiKao';
      }
      return 'YW';
    },
  },
  mounted() {
    api.getProjectList().then(({ projectList }) => {
      this.courseList = projectList;
      if (projectList.length) {
        this.selectedKey = projectList[0].code;
      }
    });
  },
  methods: {
    selectCourse(key) {
      this.selectedKey = key;
    },
    start() {
      if (!this.courseList.length) return;
      this.$emit('change', {
        scene: 'quizzesDialog',
        params: {
          course: {
            projectCode: this.selectedKey,
            type: this.type,
          },
          type: 'stage',
          mode: this.selectedKey,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .stage-test {
    position: relative;
    display: flex;
    flex-grow: 1;
    width: 100%;
    height: 100%;
    min-width: 1300px;
    min-height: 700px;
    background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/5b32f515e9c5bdc3060608759967f9a2.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .top {
      position: absolute;
      top: 0;
      z-index: 1;
      height: 20%;
      width: 100%;
      background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/39f1ae03a950d416c055a55c18152a1a.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .bottom {
      position: absolute;
      bottom: 0;
      z-index: 1;
      height: 16%;
      width: 100%;
      background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/4acce9451dd901f998e4ebe1c13c00ad.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .start {
        position: absolute;
        top: 9%;
        left: 0;
        right: 0;
        width: 9%;
        padding-top: calc(9% * 0.34);
        margin: 0 auto;
        background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/701047b32ee30b045ec94873f70a931a.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        &:active {
          transform: scale(.95);
        }
      }
    }
    .left {
      position: absolute;
      left: 0;
      height: 100%;
      width: 28%;
      background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/3037d965dfb5885a9b829a04fb2ce7f3.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .right {
      position: absolute;
      right: 0;
      height: 100%;
      width: 28%;
      background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/61dc73808b248b5244e51ee25fda34c6.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .content {
      position: absolute;
      top: 20%;
      left: 20%;
      right: 20%;
      bottom: 18%;
      width: 60%;
      height: 60%;
      z-index: 1;
      div {
        position: absolute;
        width: 24%;
        padding-top: calc(24% * 0.86);
        cursor: pointer;
      }
      .course0 {
        top: 3%;
        left: 20%;
        background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/494c4dcb4a70ac88d63f151abbe0a27e.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .course1 {
        top: 3%;
        left: 56%;
        background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/494c4dcb4a70ac88d63f151abbe0a27e.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .course2 {
        top: 23%;
        left: 2%;
        background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/494c4dcb4a70ac88d63f151abbe0a27e.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .course3 {
        top: 23%;
        left: 38%;
        background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/494c4dcb4a70ac88d63f151abbe0a27e.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .course4 {
        top: 23%;
        left: 74%;
        background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/494c4dcb4a70ac88d63f151abbe0a27e.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .course5 {
        top: 43%;
        left: 20%;
        background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/494c4dcb4a70ac88d63f151abbe0a27e.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .course6 {
        top: 43%;
        left: 56%;
        background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/494c4dcb4a70ac88d63f151abbe0a27e.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .course7 {
        top: 63%;
        left: 38%;
        background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/494c4dcb4a70ac88d63f151abbe0a27e.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .course-name{
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        height: 2vh;
        margin: auto;
        color: #fff;
        font-size: 2vh;
        line-height: 2vh;
        text-align: center;
      }
      .active{
        background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/5ef7ddda221eec0f56f8b153be93b459.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
  }
</style>
